<script setup lang="ts">
import ItemWithRadioButton from '~/components/form-elements/ItemWithRadioButton.vue'
import { useSearchboosterStore } from '~/store/searchbooster'

const searchboosterStore = useSearchboosterStore()

const classes = 'border-b-[0.5px] border-[#E2E2E2] py-3 !mb-0 [&_div]:!text-sm\n'
  + 'md:border-none md:!mb-[28px] md:mt-5 md:py-0 [&_div]:md:!text-base'

// const invertedIsExpiring = computed({
//   get () {
//     return !searchboosterStore.filter.params.isExpiring
//   },
//   set (value: boolean) {
//     searchboosterStore.filter.params.isExpiring = !value
//   }
// })
</script>

<template>
  <div>
    <ItemWithRadioButton
      v-model="searchboosterStore.filter.params.isRecommended"
      :class="classes"
      label="Рекомендуем"
    />

    <ItemWithRadioButton
      v-model="searchboosterStore.filter.params.isAvailable"
      :class="classes"
      label="В наличии"
    />
  </div>
</template>
